document.addEventListener("DOMContentLoaded", function () {

  function normalize(value) {
    return value.toLowerCase().trim().replace(/\s+/g, "-");
  }

  function filterGalleryByColor(colorValue) {
    if (!colorValue) return;

    const expectedConnect = `color_${normalize(colorValue)}`;

    const mediaGallery = document.querySelector("media-gallery");
    if (!mediaGallery) return;

    const anchor = document.querySelector(".bundle_wrap");
    const anchorTopBefore = anchor ? anchor.getBoundingClientRect().top : null;

    /* ---------------------------
       MAIN GALLERY MEDIA
    ---------------------------- */
    const mediaItems = mediaGallery.querySelectorAll(
      '.product__media[data-gang-connect]'
    );

    mediaItems.forEach(media => {
      const connect = media.dataset.gangConnect;

      media.toggleAttribute("hidden", connect !== expectedConnect);
    });

    /* ---------------------------
       THUMBNAILS (mobile)
    ---------------------------- */
    const thumbnails = mediaGallery.querySelectorAll(
      '.product__thumbnail[data-gang-connect]'
    );

    thumbnails.forEach(thumb => {
      const connect = thumb.dataset.gangConnect;

      thumb.toggleAttribute("hidden", connect !== expectedConnect);
    });

    /* ---------------------------
       IMPORTANT: notify theme
    ---------------------------- */
    mediaGallery.countMediaGallery();

    const mediaDots = mediaGallery.querySelector('media-dots');
    if (mediaDots && typeof mediaDots.resetIndexes === 'function') {
      mediaDots.resetIndexes();
    }

    if (anchor && anchorTopBefore !== null) {
      const anchorTopAfter = anchor.getBoundingClientRect().top;
      const shift = anchorTopAfter - anchorTopBefore;
      if (shift !== 0) {
        window.scrollBy({ top: shift, behavior: "instant" });
      }
    }

  }

  /* ---------------------------
     INITIAL LOAD
  ---------------------------- */
  setTimeout(() => {
    const firstCheckedColor = document.querySelector(
      '.bundle-option-swatches.color-swatches input[type="radio"]:checked'
    );

    if (firstCheckedColor) {
      filterGalleryByColor(firstCheckedColor.value);
    }
  }, 200);

  /* ---------------------------
     COLOR CHANGE
  ---------------------------- */
  document
    .querySelectorAll(".bundle-option-swatches.color-swatches input[type='radio']")
    .forEach(radio => {
      radio.addEventListener("change", function () {
        filterGalleryByColor(this.value);
      });
    });

});